<template>
<span>

    <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
        <v-container fluid grid-list-md>
            <v-row>

                <v-col cols="10" xs="12" sm="12" md="8" lg="10" xl="10">
                    <v-row>

                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <v-text-field v-model="downloadcategory.down_c_nome" :rules="rules.nomeRules" label="Nome" outlined required></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <v-text-field v-model="downloadcategory.down_c_descricao" label="Descrição" outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="d-flex flex-row">
                            <v-switch class="mr-5" color="lime" v-model="downloadcategory.down_c_status" label="Status"></v-switch>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                            <v-btn class="btn-salvar" :disabled="!valid" color="success" @click="onSubmit">
                                <v-icon class="mdi mdi-check"></v-icon>{{btnLabel}}
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-col>

                <v-col cols="2" xs="12" sm="12" md="4" lg="2" xl="2">

                    <v-layout row wrap justify-center column pt-3>

                        <v-flex d-flex justify-center v-if="previewIcone || downloadcategory.down_c_icone">
                            <v-card>
                                <v-img v-if="previewIcone" :src="previewIcone" aspect-ratio="1"></v-img>
                                <v-img v-if="downloadcategory.down_c_icone  && !previewIcone" :src="`${base_url}upload/download_category/${downloadcategory.down_c_icone}`" aspect-ratio="3"></v-img>

                                <v-card-actions class="justify-center">

                                    <v-tooltip bottom color="black lime--text">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" flat icon>
                                                <v-icon @click="$refs.fileIcone.click()">cloud_upload</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Atualizar Ícone</span>
                                    </v-tooltip>

                                    <v-tooltip bottom color="black lime--text">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" flat icon>
                                                <v-icon @click.prevent="removePreviewIcone">highlight_off</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Remover Ícone</span>
                                    </v-tooltip>

                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex d-flex justify-center>
                            <input type="file" ref="fileIcone" style="display:none;" id="fileIcone" @change="onFileIconeChange" />
                            <v-btn v-if="!previewIcone && !downloadcategory.down_c_icone" color="blue-grey" class="btn-upload white--text" @click="$refs.fileIcone.click()">
                                Adicionar Ícone
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                        </v-flex>

                        <v-flex d-flex justify-center v-if="previewImage || downloadcategory.down_c_imagem">
                            <v-card>
                                <v-img v-if="previewImage" :src="previewImage" aspect-ratio="1"></v-img>
                                <v-img v-if="downloadcategory.down_c_imagem && !previewImage" :src="`${base_url}upload/download_category/${downloadcategory.down_c_imagem}`" aspect-ratio="3"></v-img>

                                <v-card-actions class="justify-center">
                                    <v-tooltip bottom color="black lime--text">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" flat icon>
                                                <v-icon @click="$refs.fileImage.click()">cloud_upload</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Atualizar Imagem</span>
                                    </v-tooltip>
                                    <v-tooltip bottom color="black lime--text">
                                        <template v-slot:activator="{ on }">
                                            <v-btn flat icon v-on="on">
                                                <v-icon @click.prevent="removePreviewImage">highlight_off</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Remover Imagem</span>
                                    </v-tooltip>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex d-flex justify-center>
                            <input type="file" ref="fileImage" style="display:none;" id="fileImage" @change="onfileImageChange" />
                            <v-btn v-if="!previewImage && !downloadcategory.down_c_imagem" color="blue-grey" class="btn-upload white--text" @click="$refs.fileImage.click()">
                                Adicionar Imagem
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                        </v-flex>

                    </v-layout>

                </v-col>
            </v-row>
        </v-container>
    </v-form>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../../config/configs'

export default {
    name: "FormDownloadCategoryComponent",
    created() {
        //this.$store.dispatch('loadDownloadDepts');
    },
    computed: {
        //loadDownloadDepts() {
        //    return this.$store.state.downloaddepts.items.data;
        //}
    },
    props: {
        downloadcategory: {
            require: false,
            type: Object | Array,
            default: () => {
                return {
                    down_c_id: '',
                    down_c_uuid: '',
                    down_c_nome: '',
                    down_c_descricao: '',
                    down_c_icone: null,
                    down_c_imagem: null,
                    down_c_status: true,
                }
            }
        },
        update: {
            require: false,
            type: Boolean,
            default: false
        },
        btnLabel: {
            require: false,
            type: String,
            default: 'Salvar'
        },
        require: true,
    },
    data() {
        return {
            valid: true,
            rules: {
                nomeRules: [
                    v => !!v || 'Campo Nome é obrigatório',
                    v => (v && v.length <= 100) || 'Nome precisa ter até 100 Caracteres'
                ],
            },
            uploadIcone: null,
            fileNameIcone: 'Selecione uma foto',
            fileNameImage: 'Selecione uma foto',
            previewIcone: null,
            previewImage: null,
            base_url: URL_BASE
        }
    },
    methods: {
        onSubmit() {

            if (this.$refs.form.validate()) {
                const action = this.update ? 'updateDownloadCategory' : 'storeDownloadCategory';
                const msg = this.update ? 'Dados atualizados com sucesso' : 'Cadastro efetuado com sucesso';

                const formData = new FormData();

                if (this.uploadIcone !== null)
                    formData.append('down_c_icone', this.uploadIcone);

                if (this.uploadImage !== null)
                    formData.append('down_c_imagem', this.uploadImage);

                formData.append('down_c_id', this.downloadcategory.down_c_id);
                formData.append('down_c_uuid', this.downloadcategory.down_c_uuid);
                formData.append('down_c_nome', this.downloadcategory.down_c_nome);
                formData.append('down_c_descricao', this.downloadcategory.down_c_descricao);
                formData.append('down_c_icone', this.downloadcategory.down_c_icone);
                formData.append('down_c_imagem', this.downloadcategory.down_c_imagem);
                formData.append('down_c_status', this.downloadcategory.down_c_status);

                this.$store.dispatch(action, formData)
                    .then(() => {
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: msg,
                            showConfirmButton: true,
                            timer: 6000
                        });
                        this.$router.push({
                            name: 'download-categories'
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: 'Erro',
                            text: 'Algo deu errado',
                            showConfirmButton: true,
                            timer: 6000
                        });
                        this.errors = error.response.data.errors
                    })
            } else {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: 'Alguns campos requer sua atenção',
                    text: 'Verifique os campos em vermelho',
                    showConfirmButton: true,
                    timer: 6000
                });
            }

        },
        onFileIconeChange(e) {
            let files = e.target.files || e.dataTransfer.files;

            if (!files.length)
                return;

            this.uploadIcone = files[0];
            this.fileNameIcone = this.uploadIcone.name;

            this.previewIconeImage(files[0]);
        },
        onfileImageChange(e) {
            let files = e.target.files || e.dataTransfer.files;

            if (!files.length)
                return;

            this.uploadImage = files[0];
            this.fileNameImage = this.uploadImage.name;

            this.previewImagem(files[0]);
        },
        previewIconeImage(file) {

            let reader = new FileReader();
            reader.onload = (e) => {
                this.previewIcone = e.target.result;
            };
            reader.readAsDataURL(file)
        },
        previewImagem(file) {

            let reader = new FileReader();
            reader.onload = (e) => {
                this.previewImage = e.target.result;
            };
            reader.readAsDataURL(file)
        },
        removePreviewIcone() {
            this.previewIcone = null;
            this.uploadIcone = null;
            this.downloadcategory.down_c_icone = ''
        },
        removePreviewImage() {
            this.previewImage = null;
            this.uploadImage = null;
            this.downloadcategory.down_c_imagem = ''
        },
    },
    components: {

    }
};
</script>

<style scoped>
.theme--dark.v-sheet {
    background-color: #303030;
    border-color: #303030;
    color: #fff;
    box-shadow: none;
}

.btn-upload,
.btn-salvar {
    margin: 0;
}

/*Also*/
.fileinput-button input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    opacity: 0;
    -ms-filter: 'alpha(opacity=0)';
    filter: 'alpha(opacity=0)';
    font-size: 200px;
    direction: ltr;
    cursor: pointer;
}

.img-preview {
    max-width: 100%;
    height: 120px;
}
</style>
